const mr = "button, [href], input, select, textarea, [tabindex], summary";
function _r(o = document.body) {
  return o instanceof HTMLElement || (o = document.querySelector(o)), o ? Array.from(o.querySelectorAll(mr)).filter(
    (i) => !i.hasAttribute("disabled") && !i.getAttribute("aria-hidden") && i.style.display !== "none" && (!i.getAttribute("tabindex") || i.tabIndex >= 0)
  ) : (console.warn("You need to pass a parent HTMLElement"), []);
}
function ao(o = document.body) {
  const i = _r(o);
  return i.length ? i[0] : null;
}
function uo(...o) {
  try {
    return o.map((s) => [null, void 0, ""].includes(s) ? null : s && typeof s == "string" ? s : typeof s == "object" && !(s instanceof Array) ? Object.keys(s).filter((L) => s[L]).join(" ") : null).filter((s) => s).join(" ");
  } catch (i) {
    console.error(`ERROR: classes error: ${i}`);
  }
}
const St = "validFeatureFlags";
function io(o) {
  return bt()[o];
}
function so(o, i, s) {
  const c = bt() || {};
  c[o] = i, window.localStorage.setItem(St, JSON.stringify(c)), s && window.location.reload();
}
function bt() {
  const o = window.localStorage.getItem(St);
  return o ? JSON.parse(o) : null;
}
function at(o) {
  return Object.prototype.toString.call(o).slice(8, -1).toLowerCase();
}
function z(o, i) {
  const s = at(i);
  return at(o) === (s === "string" ? i : s);
}
function ut(o, ...i) {
  if (!i.length)
    return o;
  const s = i.shift();
  if (z(o, "object") && z(s, "object"))
    for (const c in s)
      z(s[c], "object") ? (o[c] || Object.assign(o, { [c]: {} }), ut(o[c], s[c])) : Object.assign(o, { [c]: s[c] });
  return ut(o, ...i);
}
class co {
  constructor(i, { origin: s = "", onBefore: c = null, onAfter: L = null } = {}) {
    this.origin = s || window.location.origin, this.routes = i, this.path = window.location.pathname, this.url = new URL(this.path, this.origin), this.route = this.getRoute(this.path), this.go = this.go.bind(this), this.getRoute = this.getRoute.bind(this), this.paramsAsObject = this.paramsAsObject.bind(this), this.updateParams = this.updateParams.bind(this), z(c, "function") && (this.onBefore = c), z(L, "function") && (this.onAfter = L);
  }
  getRoute(i) {
    return z(i, "object") ? i : this.routes[i];
  }
  paramsAsObject(i) {
    return JSON.parse(
      '{"' + decodeURI(i).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}'
    );
  }
  updateParams(i = {}) {
  }
  go(i, s = {}) {
    const {
      origin: c = "",
      replace: L = !1,
      params: S = null,
      clearParams: I = !1,
      state: b = null,
      onBefore: A = null,
      onAfter: _ = null
    } = s, d = this.getRoute(i), l = this.url, p = new URL(
      I ? i.split["?"][0] : i,
      c || this.origin
    );
    z(S, "object") && Object.keys(S).forEach((E) => {
      const C = S[E];
      p.set(E, C);
    }), l.href !== p.href && (z(A, "function") && A(p, l), z(this.onBefore, "function") && this.onBefore(p, l), history[L ? "replaceState" : "pushState"](b, "", p.pathname), z(d, "function") && d(p), this.url = p, this.route = d, this.path = this.url.pathname, z(this.onAfter, "function") && this.onAfter(p, l), z(_, "function") && _(p, l));
  }
}
function Rt(o) {
  return o && o.__esModule && Object.prototype.hasOwnProperty.call(o, "default") ? o.default : o;
}
var Ie = { exports: {} }, x = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Le, it;
function Ot() {
  if (it)
    return Le;
  it = 1;
  var o = Object.getOwnPropertySymbols, i = Object.prototype.hasOwnProperty, s = Object.prototype.propertyIsEnumerable;
  function c(S) {
    if (S == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(S);
  }
  function L() {
    try {
      if (!Object.assign)
        return !1;
      var S = new String("abc");
      if (S[5] = "de", Object.getOwnPropertyNames(S)[0] === "5")
        return !1;
      for (var I = {}, b = 0; b < 10; b++)
        I["_" + String.fromCharCode(b)] = b;
      var A = Object.getOwnPropertyNames(I).map(function(d) {
        return I[d];
      });
      if (A.join("") !== "0123456789")
        return !1;
      var _ = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(d) {
        _[d] = d;
      }), Object.keys(Object.assign({}, _)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Le = L() ? Object.assign : function(S, I) {
    for (var b, A = c(S), _, d = 1; d < arguments.length; d++) {
      b = Object(arguments[d]);
      for (var l in b)
        i.call(b, l) && (A[l] = b[l]);
      if (o) {
        _ = o(b);
        for (var p = 0; p < _.length; p++)
          s.call(b, _[p]) && (A[_[p]] = b[_[p]]);
      }
    }
    return A;
  }, Le;
}
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var st;
function Er() {
  if (st)
    return x;
  st = 1;
  var o = Ot(), i = typeof Symbol == "function" && Symbol.for, s = i ? Symbol.for("react.element") : 60103, c = i ? Symbol.for("react.portal") : 60106, L = i ? Symbol.for("react.fragment") : 60107, S = i ? Symbol.for("react.strict_mode") : 60108, I = i ? Symbol.for("react.profiler") : 60114, b = i ? Symbol.for("react.provider") : 60109, A = i ? Symbol.for("react.context") : 60110, _ = i ? Symbol.for("react.forward_ref") : 60112, d = i ? Symbol.for("react.suspense") : 60113, l = i ? Symbol.for("react.memo") : 60115, p = i ? Symbol.for("react.lazy") : 60116, E = typeof Symbol == "function" && Symbol.iterator;
  function C(r) {
    for (var u = "https://reactjs.org/docs/error-decoder.html?invariant=" + r, h = 1; h < arguments.length; h++)
      u += "&args[]=" + encodeURIComponent(arguments[h]);
    return "Minified React error #" + r + "; visit " + u + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var T = { isMounted: function() {
    return !1;
  }, enqueueForceUpdate: function() {
  }, enqueueReplaceState: function() {
  }, enqueueSetState: function() {
  } }, $ = {};
  function F(r, u, h) {
    this.props = r, this.context = u, this.refs = $, this.updater = h || T;
  }
  F.prototype.isReactComponent = {}, F.prototype.setState = function(r, u) {
    if (typeof r != "object" && typeof r != "function" && r != null)
      throw Error(C(85));
    this.updater.enqueueSetState(this, r, u, "setState");
  }, F.prototype.forceUpdate = function(r) {
    this.updater.enqueueForceUpdate(this, r, "forceUpdate");
  };
  function ee() {
  }
  ee.prototype = F.prototype;
  function j(r, u, h) {
    this.props = r, this.context = u, this.refs = $, this.updater = h || T;
  }
  var m = j.prototype = new ee();
  m.constructor = j, o(m, F.prototype), m.isPureReactComponent = !0;
  var W = { current: null }, w = Object.prototype.hasOwnProperty, V = { key: !0, ref: !0, __self: !0, __source: !0 };
  function H(r, u, h) {
    var P, y = {}, N = null, K = null;
    if (u != null)
      for (P in u.ref !== void 0 && (K = u.ref), u.key !== void 0 && (N = "" + u.key), u)
        w.call(u, P) && !V.hasOwnProperty(P) && (y[P] = u[P]);
    var D = arguments.length - 2;
    if (D === 1)
      y.children = h;
    else if (1 < D) {
      for (var Y = Array(D), J = 0; J < D; J++)
        Y[J] = arguments[J + 2];
      y.children = Y;
    }
    if (r && r.defaultProps)
      for (P in D = r.defaultProps, D)
        y[P] === void 0 && (y[P] = D[P]);
    return { $$typeof: s, type: r, key: N, ref: K, props: y, _owner: W.current };
  }
  function B(r, u) {
    return { $$typeof: s, type: r.type, key: u, ref: r.ref, props: r.props, _owner: r._owner };
  }
  function U(r) {
    return typeof r == "object" && r !== null && r.$$typeof === s;
  }
  function ae(r) {
    var u = { "=": "=0", ":": "=2" };
    return "$" + ("" + r).replace(/[=:]/g, function(h) {
      return u[h];
    });
  }
  var te = /\/+/g, re = [];
  function ie(r, u, h, P) {
    if (re.length) {
      var y = re.pop();
      return y.result = r, y.keyPrefix = u, y.func = h, y.context = P, y.count = 0, y;
    }
    return { result: r, keyPrefix: u, func: h, context: P, count: 0 };
  }
  function de(r) {
    r.result = null, r.keyPrefix = null, r.func = null, r.context = null, r.count = 0, 10 > re.length && re.push(r);
  }
  function M(r, u, h, P) {
    var y = typeof r;
    (y === "undefined" || y === "boolean") && (r = null);
    var N = !1;
    if (r === null)
      N = !0;
    else
      switch (y) {
        case "string":
        case "number":
          N = !0;
          break;
        case "object":
          switch (r.$$typeof) {
            case s:
            case c:
              N = !0;
          }
      }
    if (N)
      return h(P, r, u === "" ? "." + ue(r, 0) : u), 1;
    if (N = 0, u = u === "" ? "." : u + ":", Array.isArray(r))
      for (var K = 0; K < r.length; K++) {
        y = r[K];
        var D = u + ue(y, K);
        N += M(y, D, h, P);
      }
    else if (r === null || typeof r != "object" ? D = null : (D = E && r[E] || r["@@iterator"], D = typeof D == "function" ? D : null), typeof D == "function")
      for (r = D.call(r), K = 0; !(y = r.next()).done; )
        y = y.value, D = u + ue(y, K++), N += M(y, D, h, P);
    else if (y === "object")
      throw h = "" + r, Error(C(31, h === "[object Object]" ? "object with keys {" + Object.keys(r).join(", ") + "}" : h, ""));
    return N;
  }
  function G(r, u, h) {
    return r == null ? 0 : M(r, "", u, h);
  }
  function ue(r, u) {
    return typeof r == "object" && r !== null && r.key != null ? ae(r.key) : u.toString(36);
  }
  function se(r, u) {
    r.func.call(r.context, u, r.count++);
  }
  function _e(r, u, h) {
    var P = r.result, y = r.keyPrefix;
    r = r.func.call(r.context, u, r.count++), Array.isArray(r) ? ce(r, P, h, function(N) {
      return N;
    }) : r != null && (U(r) && (r = B(r, y + (!r.key || u && u.key === r.key ? "" : ("" + r.key).replace(te, "$&/") + "/") + h)), P.push(r));
  }
  function ce(r, u, h, P, y) {
    var N = "";
    h != null && (N = ("" + h).replace(te, "$&/") + "/"), u = ie(u, N, P, y), G(r, _e, u), de(u);
  }
  var fe = { current: null };
  function O() {
    var r = fe.current;
    if (r === null)
      throw Error(C(321));
    return r;
  }
  var he = { ReactCurrentDispatcher: fe, ReactCurrentBatchConfig: { suspense: null }, ReactCurrentOwner: W, IsSomeRendererActing: { current: !1 }, assign: o };
  return x.Children = { map: function(r, u, h) {
    if (r == null)
      return r;
    var P = [];
    return ce(r, P, null, u, h), P;
  }, forEach: function(r, u, h) {
    if (r == null)
      return r;
    u = ie(null, null, u, h), G(r, se, u), de(u);
  }, count: function(r) {
    return G(r, function() {
      return null;
    }, null);
  }, toArray: function(r) {
    var u = [];
    return ce(r, u, null, function(h) {
      return h;
    }), u;
  }, only: function(r) {
    if (!U(r))
      throw Error(C(143));
    return r;
  } }, x.Component = F, x.Fragment = L, x.Profiler = I, x.PureComponent = j, x.StrictMode = S, x.Suspense = d, x.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = he, x.cloneElement = function(r, u, h) {
    if (r == null)
      throw Error(C(267, r));
    var P = o({}, r.props), y = r.key, N = r.ref, K = r._owner;
    if (u != null) {
      if (u.ref !== void 0 && (N = u.ref, K = W.current), u.key !== void 0 && (y = "" + u.key), r.type && r.type.defaultProps)
        var D = r.type.defaultProps;
      for (Y in u)
        w.call(u, Y) && !V.hasOwnProperty(Y) && (P[Y] = u[Y] === void 0 && D !== void 0 ? D[Y] : u[Y]);
    }
    var Y = arguments.length - 2;
    if (Y === 1)
      P.children = h;
    else if (1 < Y) {
      D = Array(Y);
      for (var J = 0; J < Y; J++)
        D[J] = arguments[J + 2];
      P.children = D;
    }
    return {
      $$typeof: s,
      type: r.type,
      key: y,
      ref: N,
      props: P,
      _owner: K
    };
  }, x.createContext = function(r, u) {
    return u === void 0 && (u = null), r = { $$typeof: A, _calculateChangedBits: u, _currentValue: r, _currentValue2: r, _threadCount: 0, Provider: null, Consumer: null }, r.Provider = { $$typeof: b, _context: r }, r.Consumer = r;
  }, x.createElement = H, x.createFactory = function(r) {
    var u = H.bind(null, r);
    return u.type = r, u;
  }, x.createRef = function() {
    return { current: null };
  }, x.forwardRef = function(r) {
    return { $$typeof: _, render: r };
  }, x.isValidElement = U, x.lazy = function(r) {
    return { $$typeof: p, _ctor: r, _status: -1, _result: null };
  }, x.memo = function(r, u) {
    return { $$typeof: l, type: r, compare: u === void 0 ? null : u };
  }, x.useCallback = function(r, u) {
    return O().useCallback(r, u);
  }, x.useContext = function(r, u) {
    return O().useContext(r, u);
  }, x.useDebugValue = function() {
  }, x.useEffect = function(r, u) {
    return O().useEffect(r, u);
  }, x.useImperativeHandle = function(r, u, h) {
    return O().useImperativeHandle(r, u, h);
  }, x.useLayoutEffect = function(r, u) {
    return O().useLayoutEffect(r, u);
  }, x.useMemo = function(r, u) {
    return O().useMemo(r, u);
  }, x.useReducer = function(r, u, h) {
    return O().useReducer(r, u, h);
  }, x.useRef = function(r) {
    return O().useRef(r);
  }, x.useState = function(r) {
    return O().useState(r);
  }, x.version = "16.14.0", x;
}
var k = {}, Ae, ct;
function Sr() {
  if (ct)
    return Ae;
  ct = 1;
  var o = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Ae = o, Ae;
}
var Te, ft;
function br() {
  if (ft)
    return Te;
  ft = 1;
  var o = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var i = Sr(), s = {}, c = Function.call.bind(Object.prototype.hasOwnProperty);
    o = function(S) {
      var I = "Warning: " + S;
      typeof console < "u" && console.error(I);
      try {
        throw new Error(I);
      } catch {
      }
    };
  }
  function L(S, I, b, A, _) {
    if (process.env.NODE_ENV !== "production") {
      for (var d in S)
        if (c(S, d)) {
          var l;
          try {
            if (typeof S[d] != "function") {
              var p = Error(
                (A || "React class") + ": " + b + " type `" + d + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof S[d] + "`."
              );
              throw p.name = "Invariant Violation", p;
            }
            l = S[d](I, d, A, b, null, i);
          } catch (C) {
            l = C;
          }
          if (l && !(l instanceof Error) && o(
            (A || "React class") + ": type specification of " + b + " `" + d + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof l + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), l instanceof Error && !(l.message in s)) {
            s[l.message] = !0;
            var E = _ ? _() : "";
            o(
              "Failed " + b + " type: " + l.message + (E ?? "")
            );
          }
        }
    }
  }
  return L.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (s = {});
  }, Te = L, Te;
}
/** @license React v16.14.0
 * react.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var lt;
function Rr() {
  return lt || (lt = 1, process.env.NODE_ENV !== "production" && function() {
    var o = Ot(), i = br(), s = "16.14.0", c = typeof Symbol == "function" && Symbol.for, L = c ? Symbol.for("react.element") : 60103, S = c ? Symbol.for("react.portal") : 60106, I = c ? Symbol.for("react.fragment") : 60107, b = c ? Symbol.for("react.strict_mode") : 60108, A = c ? Symbol.for("react.profiler") : 60114, _ = c ? Symbol.for("react.provider") : 60109, d = c ? Symbol.for("react.context") : 60110, l = c ? Symbol.for("react.concurrent_mode") : 60111, p = c ? Symbol.for("react.forward_ref") : 60112, E = c ? Symbol.for("react.suspense") : 60113, C = c ? Symbol.for("react.suspense_list") : 60120, T = c ? Symbol.for("react.memo") : 60115, $ = c ? Symbol.for("react.lazy") : 60116, F = c ? Symbol.for("react.block") : 60121, ee = c ? Symbol.for("react.fundamental") : 60117, j = c ? Symbol.for("react.responder") : 60118, m = c ? Symbol.for("react.scope") : 60119, W = typeof Symbol == "function" && Symbol.iterator, w = "@@iterator";
    function V(e) {
      if (e === null || typeof e != "object")
        return null;
      var t = W && e[W] || e[w];
      return typeof t == "function" ? t : null;
    }
    var H = {
      /**
       * @internal
       * @type {ReactComponent}
       */
      current: null
    }, B = {
      suspense: null
    }, U = {
      /**
       * @internal
       * @type {ReactComponent}
       */
      current: null
    }, ae = /^(.*)[\\\/]/;
    function te(e, t, n) {
      var a = "";
      if (t) {
        var f = t.fileName, R = f.replace(ae, "");
        if (/^index\./.test(R)) {
          var v = f.match(ae);
          if (v) {
            var g = v[1];
            if (g) {
              var q = g.replace(ae, "");
              R = q + "/" + R;
            }
          }
        }
        a = " (at " + R + ":" + t.lineNumber + ")";
      } else
        n && (a = " (created by " + n + ")");
      return `
    in ` + (e || "Unknown") + a;
    }
    var re = 1;
    function ie(e) {
      return e._status === re ? e._result : null;
    }
    function de(e, t, n) {
      var a = t.displayName || t.name || "";
      return e.displayName || (a !== "" ? n + "(" + a + ")" : n);
    }
    function M(e) {
      if (e == null)
        return null;
      if (typeof e.tag == "number" && O("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof e == "function")
        return e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case I:
          return "Fragment";
        case S:
          return "Portal";
        case A:
          return "Profiler";
        case b:
          return "StrictMode";
        case E:
          return "Suspense";
        case C:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case d:
            return "Context.Consumer";
          case _:
            return "Context.Provider";
          case p:
            return de(e, e.render, "ForwardRef");
          case T:
            return M(e.type);
          case F:
            return M(e.render);
          case $: {
            var t = e, n = ie(t);
            if (n)
              return M(n);
            break;
          }
        }
      return null;
    }
    var G = {}, ue = null;
    function se(e) {
      ue = e;
    }
    G.getCurrentStack = null, G.getStackAddendum = function() {
      var e = "";
      if (ue) {
        var t = M(ue.type), n = ue._owner;
        e += te(t, ue._source, n && M(n.type));
      }
      var a = G.getCurrentStack;
      return a && (e += a() || ""), e;
    };
    var _e = {
      current: !1
    }, ce = {
      ReactCurrentDispatcher: H,
      ReactCurrentBatchConfig: B,
      ReactCurrentOwner: U,
      IsSomeRendererActing: _e,
      // Used by renderers to avoid bundling object-assign twice in UMD bundles:
      assign: o
    };
    o(ce, {
      // These should not be included in production.
      ReactDebugCurrentFrame: G,
      // Shim for React DOM 16.0.0 which still destructured (but not used) this.
      // TODO: remove in React 17.0.
      ReactComponentTreeHook: {}
    });
    function fe(e) {
      {
        for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), a = 1; a < t; a++)
          n[a - 1] = arguments[a];
        he("warn", e, n);
      }
    }
    function O(e) {
      {
        for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), a = 1; a < t; a++)
          n[a - 1] = arguments[a];
        he("error", e, n);
      }
    }
    function he(e, t, n) {
      {
        var a = n.length > 0 && typeof n[n.length - 1] == "string" && n[n.length - 1].indexOf(`
    in`) === 0;
        if (!a) {
          var f = ce.ReactDebugCurrentFrame, R = f.getStackAddendum();
          R !== "" && (t += "%s", n = n.concat([R]));
        }
        var v = n.map(function(X) {
          return "" + X;
        });
        v.unshift("Warning: " + t), Function.prototype.apply.call(console[e], console, v);
        try {
          var g = 0, q = "Warning: " + t.replace(/%s/g, function() {
            return n[g++];
          });
          throw new Error(q);
        } catch {
        }
      }
    }
    var r = {};
    function u(e, t) {
      {
        var n = e.constructor, a = n && (n.displayName || n.name) || "ReactClass", f = a + "." + t;
        if (r[f])
          return;
        O("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", t, a), r[f] = !0;
      }
    }
    var h = {
      /**
       * Checks whether or not this composite component is mounted.
       * @param {ReactClass} publicInstance The instance we want to test.
       * @return {boolean} True if mounted, false otherwise.
       * @protected
       * @final
       */
      isMounted: function(e) {
        return !1;
      },
      /**
       * Forces an update. This should only be invoked when it is known with
       * certainty that we are **not** in a DOM transaction.
       *
       * You may want to call this when you know that some deeper aspect of the
       * component's state has changed but `setState` was not called.
       *
       * This will not invoke `shouldComponentUpdate`, but it will invoke
       * `componentWillUpdate` and `componentDidUpdate`.
       *
       * @param {ReactClass} publicInstance The instance that should rerender.
       * @param {?function} callback Called after component is updated.
       * @param {?string} callerName name of the calling function in the public API.
       * @internal
       */
      enqueueForceUpdate: function(e, t, n) {
        u(e, "forceUpdate");
      },
      /**
       * Replaces all of the state. Always use this or `setState` to mutate state.
       * You should treat `this.state` as immutable.
       *
       * There is no guarantee that `this.state` will be immediately updated, so
       * accessing `this.state` after calling this method may return the old value.
       *
       * @param {ReactClass} publicInstance The instance that should rerender.
       * @param {object} completeState Next state.
       * @param {?function} callback Called after component is updated.
       * @param {?string} callerName name of the calling function in the public API.
       * @internal
       */
      enqueueReplaceState: function(e, t, n, a) {
        u(e, "replaceState");
      },
      /**
       * Sets a subset of the state. This only exists because _pendingState is
       * internal. This provides a merging strategy that is not available to deep
       * properties which is confusing. TODO: Expose pendingState or don't use it
       * during the merge.
       *
       * @param {ReactClass} publicInstance The instance that should rerender.
       * @param {object} partialState Next partial state to be merged with state.
       * @param {?function} callback Called after component is updated.
       * @param {?string} Name of the calling function in the public API.
       * @internal
       */
      enqueueSetState: function(e, t, n, a) {
        u(e, "setState");
      }
    }, P = {};
    Object.freeze(P);
    function y(e, t, n) {
      this.props = e, this.context = t, this.refs = P, this.updater = n || h;
    }
    y.prototype.isReactComponent = {}, y.prototype.setState = function(e, t) {
      if (!(typeof e == "object" || typeof e == "function" || e == null))
        throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
      this.updater.enqueueSetState(this, e, t, "setState");
    }, y.prototype.forceUpdate = function(e) {
      this.updater.enqueueForceUpdate(this, e, "forceUpdate");
    };
    {
      var N = {
        isMounted: ["isMounted", "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."],
        replaceState: ["replaceState", "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."]
      }, K = function(e, t) {
        Object.defineProperty(y.prototype, e, {
          get: function() {
            fe("%s(...) is deprecated in plain JavaScript React classes. %s", t[0], t[1]);
          }
        });
      };
      for (var D in N)
        N.hasOwnProperty(D) && K(D, N[D]);
    }
    function Y() {
    }
    Y.prototype = y.prototype;
    function J(e, t, n) {
      this.props = e, this.context = t, this.refs = P, this.updater = n || h;
    }
    var Ee = J.prototype = new Y();
    Ee.constructor = J, o(Ee, y.prototype), Ee.isPureReactComponent = !0;
    function Pt() {
      var e = {
        current: null
      };
      return Object.seal(e), e;
    }
    var ye = Object.prototype.hasOwnProperty, Ve = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ne, Ue, Se;
    Se = {};
    function Me(e) {
      if (ye.call(e, "ref")) {
        var t = Object.getOwnPropertyDescriptor(e, "ref").get;
        if (t && t.isReactWarning)
          return !1;
      }
      return e.ref !== void 0;
    }
    function qe(e) {
      if (ye.call(e, "key")) {
        var t = Object.getOwnPropertyDescriptor(e, "key").get;
        if (t && t.isReactWarning)
          return !1;
      }
      return e.key !== void 0;
    }
    function Lt(e, t) {
      var n = function() {
        Ne || (Ne = !0, O("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://fb.me/react-special-props)", t));
      };
      n.isReactWarning = !0, Object.defineProperty(e, "key", {
        get: n,
        configurable: !0
      });
    }
    function At(e, t) {
      var n = function() {
        Ue || (Ue = !0, O("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://fb.me/react-special-props)", t));
      };
      n.isReactWarning = !0, Object.defineProperty(e, "ref", {
        get: n,
        configurable: !0
      });
    }
    function Tt(e) {
      if (typeof e.ref == "string" && U.current && e.__self && U.current.stateNode !== e.__self) {
        var t = M(U.current.type);
        Se[t] || (O('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://fb.me/react-strict-mode-string-ref', M(U.current.type), e.ref), Se[t] = !0);
      }
    }
    var be = function(e, t, n, a, f, R, v) {
      var g = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: L,
        // Built-in properties that belong on the element
        type: e,
        key: t,
        ref: n,
        props: v,
        // Record the component responsible for creating this element.
        _owner: R
      };
      return g._store = {}, Object.defineProperty(g._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(g, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: a
      }), Object.defineProperty(g, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: f
      }), Object.freeze && (Object.freeze(g.props), Object.freeze(g)), g;
    };
    function xt(e, t, n) {
      var a, f = {}, R = null, v = null, g = null, q = null;
      if (t != null) {
        Me(t) && (v = t.ref, Tt(t)), qe(t) && (R = "" + t.key), g = t.__self === void 0 ? null : t.__self, q = t.__source === void 0 ? null : t.__source;
        for (a in t)
          ye.call(t, a) && !Ve.hasOwnProperty(a) && (f[a] = t[a]);
      }
      var X = arguments.length - 2;
      if (X === 1)
        f.children = n;
      else if (X > 1) {
        for (var Q = Array(X), Z = 0; Z < X; Z++)
          Q[Z] = arguments[Z + 2];
        Object.freeze && Object.freeze(Q), f.children = Q;
      }
      if (e && e.defaultProps) {
        var le = e.defaultProps;
        for (a in le)
          f[a] === void 0 && (f[a] = le[a]);
      }
      if (R || v) {
        var oe = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
        R && Lt(f, oe), v && At(f, oe);
      }
      return be(e, R, v, g, q, U.current, f);
    }
    function kt(e, t) {
      var n = be(e.type, t, e.ref, e._self, e._source, e._owner, e.props);
      return n;
    }
    function jt(e, t, n) {
      if (e == null)
        throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + e + ".");
      var a, f = o({}, e.props), R = e.key, v = e.ref, g = e._self, q = e._source, X = e._owner;
      if (t != null) {
        Me(t) && (v = t.ref, X = U.current), qe(t) && (R = "" + t.key);
        var Q;
        e.type && e.type.defaultProps && (Q = e.type.defaultProps);
        for (a in t)
          ye.call(t, a) && !Ve.hasOwnProperty(a) && (t[a] === void 0 && Q !== void 0 ? f[a] = Q[a] : f[a] = t[a]);
      }
      var Z = arguments.length - 2;
      if (Z === 1)
        f.children = n;
      else if (Z > 1) {
        for (var le = Array(Z), oe = 0; oe < Z; oe++)
          le[oe] = arguments[oe + 2];
        f.children = le;
      }
      return be(e.type, R, v, g, q, X, f);
    }
    function pe(e) {
      return typeof e == "object" && e !== null && e.$$typeof === L;
    }
    var Fe = ".", Dt = ":";
    function It(e) {
      var t = /[=:]/g, n = {
        "=": "=0",
        ":": "=2"
      }, a = ("" + e).replace(t, function(f) {
        return n[f];
      });
      return "$" + a;
    }
    var He = !1, $t = /\/+/g;
    function Be(e) {
      return ("" + e).replace($t, "$&/");
    }
    var Wt = 10, ge = [];
    function Ye(e, t, n, a) {
      if (ge.length) {
        var f = ge.pop();
        return f.result = e, f.keyPrefix = t, f.func = n, f.context = a, f.count = 0, f;
      } else
        return {
          result: e,
          keyPrefix: t,
          func: n,
          context: a,
          count: 0
        };
    }
    function ze(e) {
      e.result = null, e.keyPrefix = null, e.func = null, e.context = null, e.count = 0, ge.length < Wt && ge.push(e);
    }
    function Re(e, t, n, a) {
      var f = typeof e;
      (f === "undefined" || f === "boolean") && (e = null);
      var R = !1;
      if (e === null)
        R = !0;
      else
        switch (f) {
          case "string":
          case "number":
            R = !0;
            break;
          case "object":
            switch (e.$$typeof) {
              case L:
              case S:
                R = !0;
            }
        }
      if (R)
        return n(
          a,
          e,
          // If it's the only child, treat the name as if it was wrapped in an array
          // so that it's consistent if the number of children grows.
          t === "" ? Fe + Ce(e, 0) : t
        ), 1;
      var v, g, q = 0, X = t === "" ? Fe : t + Dt;
      if (Array.isArray(e))
        for (var Q = 0; Q < e.length; Q++)
          v = e[Q], g = X + Ce(v, Q), q += Re(v, g, n, a);
      else {
        var Z = V(e);
        if (typeof Z == "function") {
          Z === e.entries && (He || fe("Using Maps as children is deprecated and will be removed in a future major release. Consider converting children to an array of keyed ReactElements instead."), He = !0);
          for (var le = Z.call(e), oe, gr = 0; !(oe = le.next()).done; )
            v = oe.value, g = X + Ce(v, gr++), q += Re(v, g, n, a);
        } else if (f === "object") {
          var nt = "";
          nt = " If you meant to render a collection of children, use an array instead." + G.getStackAddendum();
          var ot = "" + e;
          throw Error("Objects are not valid as a React child (found: " + (ot === "[object Object]" ? "object with keys {" + Object.keys(e).join(", ") + "}" : ot) + ")." + nt);
        }
      }
      return q;
    }
    function Oe(e, t, n) {
      return e == null ? 0 : Re(e, "", t, n);
    }
    function Ce(e, t) {
      return typeof e == "object" && e !== null && e.key != null ? It(e.key) : t.toString(36);
    }
    function Vt(e, t, n) {
      var a = e.func, f = e.context;
      a.call(f, t, e.count++);
    }
    function Nt(e, t, n) {
      if (e == null)
        return e;
      var a = Ye(null, null, t, n);
      Oe(e, Vt, a), ze(a);
    }
    function Ut(e, t, n) {
      var a = e.result, f = e.keyPrefix, R = e.func, v = e.context, g = R.call(v, t, e.count++);
      Array.isArray(g) ? we(g, a, n, function(q) {
        return q;
      }) : g != null && (pe(g) && (g = kt(
        g,
        // Keep both the (mapped) and old keys if they differ, just as
        // traverseAllChildren used to do for objects as children
        f + (g.key && (!t || t.key !== g.key) ? Be(g.key) + "/" : "") + n
      )), a.push(g));
    }
    function we(e, t, n, a, f) {
      var R = "";
      n != null && (R = Be(n) + "/");
      var v = Ye(t, R, a, f);
      Oe(e, Ut, v), ze(v);
    }
    function Mt(e, t, n) {
      if (e == null)
        return e;
      var a = [];
      return we(e, a, null, t, n), a;
    }
    function qt(e) {
      return Oe(e, function() {
        return null;
      }, null);
    }
    function Ft(e) {
      var t = [];
      return we(e, t, null, function(n) {
        return n;
      }), t;
    }
    function Ht(e) {
      if (!pe(e))
        throw Error("React.Children.only expected to receive a single React element child.");
      return e;
    }
    function Bt(e, t) {
      t === void 0 ? t = null : t !== null && typeof t != "function" && O("createContext: Expected the optional second argument to be a function. Instead received: %s", t);
      var n = {
        $$typeof: d,
        _calculateChangedBits: t,
        // As a workaround to support multiple concurrent renderers, we categorize
        // some renderers as primary and others as secondary. We only expect
        // there to be two concurrent renderers at most: React Native (primary) and
        // Fabric (secondary); React DOM (primary) and React ART (secondary).
        // Secondary renderers store their context values on separate fields.
        _currentValue: e,
        _currentValue2: e,
        // Used to track how many concurrent renderers this context currently
        // supports within in a single renderer. Such as parallel server rendering.
        _threadCount: 0,
        // These are circular
        Provider: null,
        Consumer: null
      };
      n.Provider = {
        $$typeof: _,
        _context: n
      };
      var a = !1, f = !1;
      {
        var R = {
          $$typeof: d,
          _context: n,
          _calculateChangedBits: n._calculateChangedBits
        };
        Object.defineProperties(R, {
          Provider: {
            get: function() {
              return f || (f = !0, O("Rendering <Context.Consumer.Provider> is not supported and will be removed in a future major release. Did you mean to render <Context.Provider> instead?")), n.Provider;
            },
            set: function(v) {
              n.Provider = v;
            }
          },
          _currentValue: {
            get: function() {
              return n._currentValue;
            },
            set: function(v) {
              n._currentValue = v;
            }
          },
          _currentValue2: {
            get: function() {
              return n._currentValue2;
            },
            set: function(v) {
              n._currentValue2 = v;
            }
          },
          _threadCount: {
            get: function() {
              return n._threadCount;
            },
            set: function(v) {
              n._threadCount = v;
            }
          },
          Consumer: {
            get: function() {
              return a || (a = !0, O("Rendering <Context.Consumer.Consumer> is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?")), n.Consumer;
            }
          }
        }), n.Consumer = R;
      }
      return n._currentRenderer = null, n._currentRenderer2 = null, n;
    }
    function Yt(e) {
      var t = {
        $$typeof: $,
        _ctor: e,
        // React uses these fields to store the result.
        _status: -1,
        _result: null
      };
      {
        var n, a;
        Object.defineProperties(t, {
          defaultProps: {
            configurable: !0,
            get: function() {
              return n;
            },
            set: function(f) {
              O("React.lazy(...): It is not supported to assign `defaultProps` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."), n = f, Object.defineProperty(t, "defaultProps", {
                enumerable: !0
              });
            }
          },
          propTypes: {
            configurable: !0,
            get: function() {
              return a;
            },
            set: function(f) {
              O("React.lazy(...): It is not supported to assign `propTypes` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."), a = f, Object.defineProperty(t, "propTypes", {
                enumerable: !0
              });
            }
          }
        });
      }
      return t;
    }
    function zt(e) {
      return e != null && e.$$typeof === T ? O("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).") : typeof e != "function" ? O("forwardRef requires a render function but was given %s.", e === null ? "null" : typeof e) : e.length !== 0 && e.length !== 2 && O("forwardRef render functions accept exactly two parameters: props and ref. %s", e.length === 1 ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined."), e != null && (e.defaultProps != null || e.propTypes != null) && O("forwardRef render functions do not support propTypes or defaultProps. Did you accidentally pass a React component?"), {
        $$typeof: p,
        render: e
      };
    }
    function Ge(e) {
      return typeof e == "string" || typeof e == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      e === I || e === l || e === A || e === b || e === E || e === C || typeof e == "object" && e !== null && (e.$$typeof === $ || e.$$typeof === T || e.$$typeof === _ || e.$$typeof === d || e.$$typeof === p || e.$$typeof === ee || e.$$typeof === j || e.$$typeof === m || e.$$typeof === F);
    }
    function Gt(e, t) {
      return Ge(e) || O("memo: The first argument must be a component. Instead received: %s", e === null ? "null" : typeof e), {
        $$typeof: T,
        type: e,
        compare: t === void 0 ? null : t
      };
    }
    function ne() {
      var e = H.current;
      if (e === null)
        throw Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://fb.me/react-invalid-hook-call for tips about how to debug and fix this problem.`);
      return e;
    }
    function Kt(e, t) {
      var n = ne();
      if (t !== void 0 && O("useContext() second argument is reserved for future use in React. Passing it is not supported. You passed: %s.%s", t, typeof t == "number" && Array.isArray(arguments[2]) ? `

Did you call array.map(useContext)? Calling Hooks inside a loop is not supported. Learn more at https://fb.me/rules-of-hooks` : ""), e._context !== void 0) {
        var a = e._context;
        a.Consumer === e ? O("Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be removed in a future major release. Did you mean to call useContext(Context) instead?") : a.Provider === e && O("Calling useContext(Context.Provider) is not supported. Did you mean to call useContext(Context) instead?");
      }
      return n.useContext(e, t);
    }
    function Jt(e) {
      var t = ne();
      return t.useState(e);
    }
    function Xt(e, t, n) {
      var a = ne();
      return a.useReducer(e, t, n);
    }
    function Zt(e) {
      var t = ne();
      return t.useRef(e);
    }
    function Qt(e, t) {
      var n = ne();
      return n.useEffect(e, t);
    }
    function er(e, t) {
      var n = ne();
      return n.useLayoutEffect(e, t);
    }
    function tr(e, t) {
      var n = ne();
      return n.useCallback(e, t);
    }
    function rr(e, t) {
      var n = ne();
      return n.useMemo(e, t);
    }
    function nr(e, t, n) {
      var a = ne();
      return a.useImperativeHandle(e, t, n);
    }
    function or(e, t) {
      {
        var n = ne();
        return n.useDebugValue(e, t);
      }
    }
    var Pe;
    Pe = !1;
    function Ke() {
      if (U.current) {
        var e = M(U.current.type);
        if (e)
          return `

Check the render method of \`` + e + "`.";
      }
      return "";
    }
    function ar(e) {
      if (e !== void 0) {
        var t = e.fileName.replace(/^.*[\\\/]/, ""), n = e.lineNumber;
        return `

Check your code at ` + t + ":" + n + ".";
      }
      return "";
    }
    function ur(e) {
      return e != null ? ar(e.__source) : "";
    }
    var Je = {};
    function ir(e) {
      var t = Ke();
      if (!t) {
        var n = typeof e == "string" ? e : e.displayName || e.name;
        n && (t = `

Check the top-level render call using <` + n + ">.");
      }
      return t;
    }
    function Xe(e, t) {
      if (!(!e._store || e._store.validated || e.key != null)) {
        e._store.validated = !0;
        var n = ir(t);
        if (!Je[n]) {
          Je[n] = !0;
          var a = "";
          e && e._owner && e._owner !== U.current && (a = " It was passed a child from " + M(e._owner.type) + "."), se(e), O('Each child in a list should have a unique "key" prop.%s%s See https://fb.me/react-warning-keys for more information.', n, a), se(null);
        }
      }
    }
    function Ze(e, t) {
      if (typeof e == "object") {
        if (Array.isArray(e))
          for (var n = 0; n < e.length; n++) {
            var a = e[n];
            pe(a) && Xe(a, t);
          }
        else if (pe(e))
          e._store && (e._store.validated = !0);
        else if (e) {
          var f = V(e);
          if (typeof f == "function" && f !== e.entries)
            for (var R = f.call(e), v; !(v = R.next()).done; )
              pe(v.value) && Xe(v.value, t);
        }
      }
    }
    function Qe(e) {
      {
        var t = e.type;
        if (t == null || typeof t == "string")
          return;
        var n = M(t), a;
        if (typeof t == "function")
          a = t.propTypes;
        else if (typeof t == "object" && (t.$$typeof === p || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        t.$$typeof === T))
          a = t.propTypes;
        else
          return;
        a ? (se(e), i(a, e.props, "prop", n, G.getStackAddendum), se(null)) : t.PropTypes !== void 0 && !Pe && (Pe = !0, O("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", n || "Unknown")), typeof t.getDefaultProps == "function" && !t.getDefaultProps.isReactClassApproved && O("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function sr(e) {
      {
        se(e);
        for (var t = Object.keys(e.props), n = 0; n < t.length; n++) {
          var a = t[n];
          if (a !== "children" && a !== "key") {
            O("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", a);
            break;
          }
        }
        e.ref !== null && O("Invalid attribute `ref` supplied to `React.Fragment`."), se(null);
      }
    }
    function et(e, t, n) {
      var a = Ge(e);
      if (!a) {
        var f = "";
        (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (f += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
        var R = ur(t);
        R ? f += R : f += Ke();
        var v;
        e === null ? v = "null" : Array.isArray(e) ? v = "array" : e !== void 0 && e.$$typeof === L ? (v = "<" + (M(e.type) || "Unknown") + " />", f = " Did you accidentally export a JSX literal instead of a component?") : v = typeof e, O("React.createElement: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", v, f);
      }
      var g = xt.apply(this, arguments);
      if (g == null)
        return g;
      if (a)
        for (var q = 2; q < arguments.length; q++)
          Ze(arguments[q], e);
      return e === I ? sr(g) : Qe(g), g;
    }
    var tt = !1;
    function cr(e) {
      var t = et.bind(null, e);
      return t.type = e, tt || (tt = !0, fe("React.createFactory() is deprecated and will be removed in a future major release. Consider using JSX or use React.createElement() directly instead.")), Object.defineProperty(t, "type", {
        enumerable: !1,
        get: function() {
          return fe("Factory.type is deprecated. Access the class directly before passing it to createFactory."), Object.defineProperty(this, "type", {
            value: e
          }), e;
        }
      }), t;
    }
    function fr(e, t, n) {
      for (var a = jt.apply(this, arguments), f = 2; f < arguments.length; f++)
        Ze(arguments[f], a.type);
      return Qe(a), a;
    }
    try {
      var rt = Object.freeze({}), lr = /* @__PURE__ */ new Map([[rt, null]]), dr = /* @__PURE__ */ new Set([rt]);
      lr.set(0, 0), dr.add(0);
    } catch {
    }
    var pr = et, vr = fr, hr = cr, yr = {
      map: Mt,
      forEach: Nt,
      count: qt,
      toArray: Ft,
      only: Ht
    };
    k.Children = yr, k.Component = y, k.Fragment = I, k.Profiler = A, k.PureComponent = J, k.StrictMode = b, k.Suspense = E, k.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ce, k.cloneElement = vr, k.createContext = Bt, k.createElement = pr, k.createFactory = hr, k.createRef = Pt, k.forwardRef = zt, k.isValidElement = pe, k.lazy = Yt, k.memo = Gt, k.useCallback = tr, k.useContext = Kt, k.useDebugValue = or, k.useEffect = Qt, k.useImperativeHandle = nr, k.useLayoutEffect = er, k.useMemo = rr, k.useReducer = Xt, k.useRef = Zt, k.useState = Jt, k.version = s;
  }()), k;
}
process.env.NODE_ENV === "production" ? Ie.exports = Er() : Ie.exports = Rr();
var ve = Ie.exports;
const Ct = /* @__PURE__ */ Rt(ve);
function fo(o, i) {
  Ct.useEffect(() => {
    function s(c) {
      z(i, "function") && o.current && !o.current.contains(c.target) && i(o);
    }
    return document.addEventListener("click", s), () => {
      document.removeEventListener("click", s);
    };
  }, [o]);
}
var Or = { BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0, SSR: !1 };
const dt = (o) => {
  let i;
  const s = /* @__PURE__ */ new Set(), c = (d, l) => {
    const p = typeof d == "function" ? d(i) : d;
    if (!Object.is(p, i)) {
      const E = i;
      i = l ?? (typeof p != "object" || p === null) ? p : Object.assign({}, i, p), s.forEach((C) => C(i, E));
    }
  }, L = () => i, A = { setState: c, getState: L, getInitialState: () => _, subscribe: (d) => (s.add(d), () => s.delete(d)), destroy: () => {
    (Or ? "production" : void 0) !== "production" && console.warn(
      "[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected."
    ), s.clear();
  } }, _ = i = o(c, L, A);
  return A;
}, Cr = (o) => o ? dt(o) : dt;
var $e = { exports: {} }, xe = {}, me = { exports: {} }, ke = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var pt;
function wr() {
  if (pt)
    return ke;
  pt = 1;
  var o = ve;
  function i(l, p) {
    return l === p && (l !== 0 || 1 / l === 1 / p) || l !== l && p !== p;
  }
  var s = typeof Object.is == "function" ? Object.is : i, c = o.useState, L = o.useEffect, S = o.useLayoutEffect, I = o.useDebugValue;
  function b(l, p) {
    var E = p(), C = c({ inst: { value: E, getSnapshot: p } }), T = C[0].inst, $ = C[1];
    return S(function() {
      T.value = E, T.getSnapshot = p, A(T) && $({ inst: T });
    }, [l, E, p]), L(function() {
      return A(T) && $({ inst: T }), l(function() {
        A(T) && $({ inst: T });
      });
    }, [l]), I(E), E;
  }
  function A(l) {
    var p = l.getSnapshot;
    l = l.value;
    try {
      var E = p();
      return !s(l, E);
    } catch {
      return !0;
    }
  }
  function _(l, p) {
    return p();
  }
  var d = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? _ : b;
  return ke.useSyncExternalStore = o.useSyncExternalStore !== void 0 ? o.useSyncExternalStore : d, ke;
}
var je = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var vt;
function Pr() {
  return vt || (vt = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var o = ve, i = o.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function s(j) {
      {
        for (var m = arguments.length, W = new Array(m > 1 ? m - 1 : 0), w = 1; w < m; w++)
          W[w - 1] = arguments[w];
        c("error", j, W);
      }
    }
    function c(j, m, W) {
      {
        var w = i.ReactDebugCurrentFrame, V = w.getStackAddendum();
        V !== "" && (m += "%s", W = W.concat([V]));
        var H = W.map(function(B) {
          return String(B);
        });
        H.unshift("Warning: " + m), Function.prototype.apply.call(console[j], console, H);
      }
    }
    function L(j, m) {
      return j === m && (j !== 0 || 1 / j === 1 / m) || j !== j && m !== m;
    }
    var S = typeof Object.is == "function" ? Object.is : L, I = o.useState, b = o.useEffect, A = o.useLayoutEffect, _ = o.useDebugValue, d = !1, l = !1;
    function p(j, m, W) {
      d || o.startTransition !== void 0 && (d = !0, s("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
      var w = m();
      if (!l) {
        var V = m();
        S(w, V) || (s("The result of getSnapshot should be cached to avoid an infinite loop"), l = !0);
      }
      var H = I({
        inst: {
          value: w,
          getSnapshot: m
        }
      }), B = H[0].inst, U = H[1];
      return A(function() {
        B.value = w, B.getSnapshot = m, E(B) && U({
          inst: B
        });
      }, [j, w, m]), b(function() {
        E(B) && U({
          inst: B
        });
        var ae = function() {
          E(B) && U({
            inst: B
          });
        };
        return j(ae);
      }, [j]), _(w), w;
    }
    function E(j) {
      var m = j.getSnapshot, W = j.value;
      try {
        var w = m();
        return !S(W, w);
      } catch {
        return !0;
      }
    }
    function C(j, m, W) {
      return m();
    }
    var T = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", $ = !T, F = $ ? C : p, ee = o.useSyncExternalStore !== void 0 ? o.useSyncExternalStore : F;
    je.useSyncExternalStore = ee, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), je;
}
var ht;
function wt() {
  return ht || (ht = 1, process.env.NODE_ENV === "production" ? me.exports = wr() : me.exports = Pr()), me.exports;
}
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var yt;
function Lr() {
  if (yt)
    return xe;
  yt = 1;
  var o = ve, i = wt();
  function s(_, d) {
    return _ === d && (_ !== 0 || 1 / _ === 1 / d) || _ !== _ && d !== d;
  }
  var c = typeof Object.is == "function" ? Object.is : s, L = i.useSyncExternalStore, S = o.useRef, I = o.useEffect, b = o.useMemo, A = o.useDebugValue;
  return xe.useSyncExternalStoreWithSelector = function(_, d, l, p, E) {
    var C = S(null);
    if (C.current === null) {
      var T = { hasValue: !1, value: null };
      C.current = T;
    } else
      T = C.current;
    C = b(function() {
      function F(w) {
        if (!ee) {
          if (ee = !0, j = w, w = p(w), E !== void 0 && T.hasValue) {
            var V = T.value;
            if (E(V, w))
              return m = V;
          }
          return m = w;
        }
        if (V = m, c(j, w))
          return V;
        var H = p(w);
        return E !== void 0 && E(V, H) ? V : (j = w, m = H);
      }
      var ee = !1, j, m, W = l === void 0 ? null : l;
      return [function() {
        return F(d());
      }, W === null ? void 0 : function() {
        return F(W());
      }];
    }, [d, l, p, E]);
    var $ = L(_, C[0], C[1]);
    return I(function() {
      T.hasValue = !0, T.value = $;
    }, [$]), A($), $;
  }, xe;
}
var De = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var gt;
function Ar() {
  return gt || (gt = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var o = ve, i = wt();
    function s(d, l) {
      return d === l && (d !== 0 || 1 / d === 1 / l) || d !== d && l !== l;
    }
    var c = typeof Object.is == "function" ? Object.is : s, L = i.useSyncExternalStore, S = o.useRef, I = o.useEffect, b = o.useMemo, A = o.useDebugValue;
    function _(d, l, p, E, C) {
      var T = S(null), $;
      T.current === null ? ($ = {
        hasValue: !1,
        value: null
      }, T.current = $) : $ = T.current;
      var F = b(function() {
        var W = !1, w, V, H = function(te) {
          if (!W) {
            W = !0, w = te;
            var re = E(te);
            if (C !== void 0 && $.hasValue) {
              var ie = $.value;
              if (C(ie, re))
                return V = ie, ie;
            }
            return V = re, re;
          }
          var de = w, M = V;
          if (c(de, te))
            return M;
          var G = E(te);
          return C !== void 0 && C(M, G) ? M : (w = te, V = G, G);
        }, B = p === void 0 ? null : p, U = function() {
          return H(l());
        }, ae = B === null ? void 0 : function() {
          return H(B());
        };
        return [U, ae];
      }, [l, p, E, C]), ee = F[0], j = F[1], m = L(d, ee, j);
      return I(function() {
        $.hasValue = !0, $.value = m;
      }, [m]), A(m), m;
    }
    De.useSyncExternalStoreWithSelector = _, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), De;
}
process.env.NODE_ENV === "production" ? $e.exports = Lr() : $e.exports = Ar();
var Tr = $e.exports;
const xr = /* @__PURE__ */ Rt(Tr);
var We = { BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0, SSR: !1 };
const { useDebugValue: kr } = Ct, { useSyncExternalStoreWithSelector: jr } = xr;
let mt = !1;
const Dr = (o) => o;
function Ir(o, i = Dr, s) {
  (We ? "production" : void 0) !== "production" && s && !mt && (console.warn(
    "[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937"
  ), mt = !0);
  const c = jr(
    o.subscribe,
    o.getState,
    o.getServerState || o.getInitialState,
    i,
    s
  );
  return kr(c), c;
}
const _t = (o) => {
  (We ? "production" : void 0) !== "production" && typeof o != "function" && console.warn(
    "[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`."
  );
  const i = typeof o == "function" ? Cr(o) : o, s = (c, L) => Ir(i, c, L);
  return Object.assign(s, i), s;
}, $r = (o) => o ? _t(o) : _t;
var Wr = (o) => ((We ? "production" : void 0) !== "production" && console.warn(
  "[DEPRECATED] Default export is deprecated. Instead use `import { create } from 'zustand'`."
), $r(o));
const Et = {
  loading: !1,
  // Whether page content is loading.
  leftNav: {
    show: !1,
    // Whether LeftNav is displayed.
    showHeader: !0,
    // Whether to show LeftNav header (if one is configured).
    pinned: !0,
    // Whether LeftNav is pinned.
    menus: {}
    // Provides an optional method for tracking open state of left nav menus across mounts. Signature: { [title]: openState }.
  },
  go: null,
  // Default onClick handler for global links.
  dom: {
    // Current DOM elements.
    topBar: null,
    leftNav: null,
    content: null
  }
}, lo = Wr((o, i) => ({
  ...Et,
  // Toggle loading for page content.
  toggleLoading: (s) => o((c) => ({
    loading: z(s, "boolean") ? s : !c.loading
  })),
  // Update leftNav state.
  setLeftNav: (s = {}) => o((c) => ({
    leftNav: {
      ...c.leftNav,
      ...s
    }
  })),
  // Update DOM elements.
  setDom: (s = {}) => o((c) => ({
    dom: {
      ...c.dom,
      ...s
    }
  })),
  // Toggle leftNav.pinned.
  toggleLeftNav: (s) => o((c) => ({
    leftNav: {
      ...c.leftNav,
      pinned: z(s, "boolean") ? s : !c.leftNav.pinned
    }
  })),
  // Toggle leftNav.showHeader.
  toggleLeftNavHeader: (s) => o((c) => ({
    leftNav: {
      ...c.leftNav,
      showHeader: z(s, "boolean") ? s : !c.leftNav.showHeader
    }
  })),
  // Set the default onClick handler for global links.
  setGo: (s) => o((c) => ({ go: s })),
  // Reset all of Volt State.
  reset: () => o({ ...Et })
})), Vr = "#476ed1", Nr = "#c9462c", Ur = "#05805b", Mr = "#c9315b", qr = "#7e5eba", Fr = "#017d92", Hr = "#6256e9", Br = "#6256e9", Yr = "#0093e8", zr = "#0093e8", Gr = "#feff84", Kr = "#feff84", Jr = "#feff8466", Xr = "#feff8466", Zr = "#3b2ce3", Qr = "#3b2ce3", en = "#2100d9", tn = "#1e1672", rn = "#b4ccfc", nn = "#e9f0fe", on = "#f8fafd", an = "#2100d9", un = "#1e1672", sn = "#b4ccfc", cn = "#e9f0fe", fn = "#f8fafd", ln = "#1a8198", dn = "#13d0c5", pn = "#13d0c5", vn = "#00041e", hn = "#262631", yn = "#434355", gn = "#666679", mn = "#a7a8bd", _n = "#dedfe6", En = "#f0f0f3", Sn = "#f8f9f9", bn = "#80a4ff", Rn = "#b20030", On = "#b20030", Cn = "#a0012c", wn = "#f28a97", Pn = "#ffeaed", Ln = "#a0012c", An = "#f28a97", Tn = "#ffeaed", xn = "#2a206a", kn = "#2a206a", jn = "#602865", Dn = "#9f5ab1", In = "#9f5ab1", $n = "#1cc283", Wn = "#1cc283", Vn = "#434355", Nn = "#cdced9", Un = "#cdced9", Mn = "#f0f0f3", qn = "#ff304a", Fn = "#ff304a", Hn = "#ffeaed", Bn = "#f0f0f3", Yn = "#16accd", zn = "#16accd", Gn = "#e5f7fc", Kn = "#3db65c", Jn = "#3db65c", Xn = "#e4fcea", Zn = "#ffc13b", Qn = "#ffc13b", eo = "#fff4de", to = "#a1dadd", ro = "#f2f4ff", no = "#f2f4ff", oo = "#ffffff", po = {
  aaBlue: Vr,
  aaBurnt: Nr,
  aaGreen: Ur,
  aaMagenta: Mr,
  aaPurple: qr,
  aaTeal: Fr,
  accent: Hr,
  accentColor: Br,
  accentEducation: Yr,
  accentEducationColor: zr,
  accentHighlight: Gr,
  accentHighlightColor: Kr,
  accentHighlightColorTransparent: Jr,
  accentHighlightTransparent: Xr,
  action: Zr,
  actionColor: Qr,
  actionColorDarker1: en,
  actionColorDarker2: tn,
  actionColorLighter1: rn,
  actionColorLighter2: nn,
  actionColorLighter3: on,
  actionDarker1: an,
  actionDarker2: un,
  actionLighter1: sn,
  actionLighter2: cn,
  actionLighter3: fn,
  aqua: ln,
  aquaLight1: dn,
  aquaLighter1: pn,
  blackLighter1: vn,
  blackLighter2: hn,
  blackLighter3: yn,
  blackLighter4: gn,
  blackLighter5: mn,
  blackLighter6: _n,
  blackLighter7: En,
  blackLighter8: Sn,
  blueLight: bn,
  danger: Rn,
  dangerColor: On,
  dangerColorDarker1: Cn,
  dangerColorLighter1: wn,
  dangerColorLighter2: Pn,
  dangerDarker1: Ln,
  dangerLighter1: An,
  dangerLighter2: Tn,
  logo: xn,
  logoColor: kn,
  royal: jn,
  royalLight1: Dn,
  royalLighter1: In,
  secondary: $n,
  secondaryColor: Wn,
  statusDarkWash: Vn,
  statusDraft: Nn,
  statusDraftColor: Un,
  statusDraftWash: Mn,
  statusError: qn,
  statusErrorColor: Fn,
  statusErrorWash: Hn,
  statusLightWash: Bn,
  statusPending: Yn,
  statusPendingColor: zn,
  statusPendingWash: Gn,
  statusSuccess: Kn,
  statusSuccessColor: Jn,
  statusSuccessWash: Xn,
  statusWarning: Zn,
  statusWarningColor: Qn,
  statusWarningWash: eo,
  tealLight: to,
  wash: ro,
  washColor: no,
  white: oo
};
export {
  St as LOCAL_FLAGS_ID,
  co as Router,
  uo as classes,
  po as colors,
  Et as defaultVoltState,
  _r as getAllFocusables,
  ao as getFirstFocusable,
  io as getLocalFlag,
  bt as getLocalFlags,
  z as isType,
  ut as mergeDeep,
  so as setLocalFlag,
  at as trueType,
  fo as useOnClickOutside,
  lo as useVoltState
};
